import React, {FC, useEffect, useMemo, useState} from "react";
import Glide from "@glidejs/glide";
import useNcId from "hooks/useNcId";
import {BannerType} from "data/types";

export interface SectionSliderBannerProps {
  className?: string;
  itemClassName?: string;
  banners: BannerType[];
  uniqueClassName: string;
}

const SectionSliderBanner: FC<SectionSliderBannerProps> = ({
  className = "",
  itemClassName = "",
  banners,
  uniqueClassName,
}) => {
  const UNIQUE_CLASS =
    "SectionSliderNewCategories__" + uniqueClassName + useNcId();
  const [, setActiveIndex] = useState(0);

  const MY_GLIDEJS = useMemo(() => {
    return new Glide(`.${UNIQUE_CLASS}`, {
      type: "carousel",
      perView: 1,
      focusAt: "center",
      gap: 8,
      peek: {before: 0, after: 60}, // laterales parcialmente visibles
      autoplay: 4000,
      animationDuration: 600,
      breakpoints: {
        1024: {perView: 2, peek: {before: 0, after: 40}},
        768: {perView: 1, peek: {before: 0, after: 20}},
      },
    });
  }, [UNIQUE_CLASS]);

  useEffect(() => {
    if (MY_GLIDEJS && MY_GLIDEJS.mount) {
      MY_GLIDEJS.on("run.after", () => setActiveIndex(MY_GLIDEJS.index));
      MY_GLIDEJS.mount();
    }
  }, [MY_GLIDEJS]);

  return (
    <div className={`nc-SectionSliderNewCategories ${className} mt-12`}>
      <div className={`${UNIQUE_CLASS} flow-root overflow-hidden`}>
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides flex justify-center items-center">
            {banners.map((item, index) => {
              return (
                <li
                  key={index}
                  className={`glide__slide ${itemClassName} flex justify-center items-center`}
                >
                  <div className="relative w-full aspect-[4/1] rounded-3xl overflow-hidden">
                    <img
                      className="absolute inset-0 w-full h-full object-cover"
                      src={item.img}
                      alt={`banner-${index}`}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SectionSliderBanner;
